module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "showLegend": true,
      "legendPosition": 'bottom',
      "data": _vm.processGenderStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender / Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processGenderProvinceStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender / Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processGenderPopulationGroupStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processProvinceStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province / Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processProvinceAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province / Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processProvincePopulationGroupStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processPopulationGroupStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group / Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processPopulationGroupAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group / LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processPopulationGroupLsmStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age / LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processAgeLsmStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age / Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processAgeGenderStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processLsmStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM / Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processLsmProvince
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM / Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processLsmGender
    }
  })], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3847d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/AudienceDashboard.vue
// module id = 3167
// module chunks = 3